package com.exura.features.demofeatures.domain.model

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("CheckFeatureEnabledResponse")
data class CheckFeatureEnabledResponse(
    @JsName("isEnabled")
    val isEnabled: Boolean
)
